export default {
    set(key, val) {
        if (typeof val === 'object') {
            val = JSON.stringify(val)
        }
        localStorage.setItem(key, val)
    },
    get(key) {
        const val = localStorage.getItem(key)
        try {
            return val && JSON.parse(val)
        } catch (error) {
            return val
        }
    },
    addItem (key, val) {
        const arr = this.get(key) || []
        if (typeof val == 'string') {
            if (arr.indexOf(val) === -1) {
                arr.push(val)
                this.set(key, arr)
            }
            return arr
        }
        let item = arr.find(item => {
            return item.id == val.id
        })
        if (!item) {
            arr.push(val)
            this.set(key, arr)
        }
        return arr
    },
    remove(key) {
        return  localStorage.removeItem(key)
    },
    clearAll() {
        localStorage.clear()
    }
};